class EventService {
    constructor($http, authenticationService, globalConstants) {
        this.$http = $http;
        this.token = authenticationService.getToken();
        this.$http.defaults.headers.common.Authorization = 'Bearer ' + this.token;
        this.globalConstants = globalConstants;
    }

    getAll(query) {
        return this.$http({
            method: 'GET',
            url: this.globalConstants.ApiBaseUrl + '/api/events',
            params: query
        });
    }

    getByClient(query) {
        return this.$http({
            method: 'GET',
            url: this.globalConstants.ApiBaseUrl + '/api/events/getByClient',
            params: query
        });
    }

    getBySubscription(query) {
        return this.$http({
            method: 'GET',
            url: this.globalConstants.ApiBaseUrl + '/api/events/getBySubscription',
            params: query
        });
    }

    get(id) {
        return this.$http({
            method: 'GET',
            url: this.globalConstants.ApiBaseUrl +'/api/events/' + id
        });
    }

    add(event) {
        return this.$http({
            method: 'POST',
            url: this.globalConstants.ApiBaseUrl +'/api/events',
            data: event
        });
    }

    updateEvent(event){
        event.eventUsers = [];
        return this.$http({
            method: 'PUT',
            url: this.globalConstants.ApiBaseUrl + '/api/events/updateEvent',
            data: event
        })
    }


    delete(id) {
        return this.$http({
            method: 'DELETE',
            url: this.globalConstants.ApiBaseUrl + '/api/events/' + id
        });
    }
    
    assignTrainee(eventTrainee) {
        return this.$http({
            method: 'POST',
            url: this.globalConstants.ApiBaseUrl +'/api/events/assigntrainee',
            data: eventTrainee
        });
    }

    unassignTrainee(eventTrainee) {
        return this.$http({
            method: 'POST',
            url: this.globalConstants.ApiBaseUrl + '/api/events/unassigntrainee',
            data: eventTrainee
        });
    }
}

export default EventService;


// WEBPACK FOOTER //
// ./src/js/services/event.service.js